import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { Helmet } from 'react-helmet';
// Meta Pixel Code
const MetaPixel = () => <Helmet data-id="element-230">
    <script data-id="element-231">
      {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1392823912626349');
        fbq('track', 'PageView');
      `}
    </script>
    <noscript data-id="element-232">
      {`<img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=1392823912626349&ev=PageView&noscript=1"
      />`}
    </noscript>
  </Helmet>;
const rootElement = document.getElementById('root');
if (rootElement) {
  render(<>
      <MetaPixel data-id="element-233" />
      <App data-id="element-234" />
    </>, rootElement);
}